"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonButtonStyles = void 0;
var _styledComponents = require("styled-components");
var CommonButtonStyles = (0, _styledComponents.css)(["box-sizing:border-box;position:relative;display:inline-block;line-height:1.5rem;max-width:100%;", " font-family:'Untitled Sans',sans-serif;font-size:1rem;text-align:left;cursor:pointer;user-select:none;"], function (props) {
  return props.disabled && " opacity: 0.3;\n      pointer-events: none;\n    ";
});
exports.CommonButtonStyles = CommonButtonStyles;